import type { ReactNode } from 'react'

/**
 * §11.3 shared primitive — horizontally scrollable chip row with a subtle
 * fade-mask on both edges so the user gets a visual cue that more chips
 * hide off-screen. Also fixes §8.2.1.
 *
 * Content is fully render-prop; this component only owns the wrapper + the
 * mask.
 */
export const ChipRow = ({
  children,
  ariaLabel,
  role = 'group',
  className,
}: {
  children: ReactNode
  ariaLabel?: string
  role?: 'group' | 'tablist' | 'toolbar'
  className?: string
}) => (
  <div className={['chipRow', className ?? ''].filter(Boolean).join(' ')}>
    <div className="chipRowScroll" role={role} aria-label={ariaLabel}>
      {children}
    </div>
  </div>
)
